export { default } from './withStyles';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/styles/esm/withStyles/index.js
// module id = 851
// module chunks = 121